import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  // Sync <html lang> + document.title for SEO when language changes
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;

      // Skip default title management on city pages — they manage their own SEO meta
      const path = typeof window !== "undefined" ? window.location.pathname : "/";
      if (path.startsWith("/shipping-to/")) return;

      if (lang === "es") {
        document.title =
          "Ship Costa Rica | Envío Aéreo de Miami a Costa Rica · $15 por kilo a tu puerta";
        const desc = document.querySelector('meta[name="description"]');
        if (desc) {
          desc.setAttribute(
            "content",
            "Ship Costa Rica es el servicio confiable de envío aéreo y casillero en Miami para Costa Rica. Compra en Amazon, eBay, SHEIN, Walmart y entregamos a tu puerta en 5–7 días por $15/kilo. Atención 24/7."
          );
        }
      } else {
        document.title =
          "Ship Costa Rica | Trusted Air Shipping from Miami to Costa Rica · $15/kilo Door-to-Door";
        const desc = document.querySelector('meta[name="description"]');
        if (desc) {
          desc.setAttribute(
            "content",
            "Ship Costa Rica is the trusted Miami → Costa Rica package forwarding & air shipping service. Shop Amazon, eBay, SHEIN, Walmart, Best Buy and more — we deliver to your door anywhere in Costa Rica in 5–7 days for $15/kilo. 24/7 customer service. Free Miami warehouse address."
          );
        }
      }
    }
  }, [lang]);

  const value = useMemo(() => {
    return {
      lang,
      setLang,
      t: translations[lang],
      toggle: () => setLang((prev) => (prev === "en" ? "es" : "en")),
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
